export const classifySourceUrl = (url: string | null | undefined): string | undefined => {
	if (!url) {
		return undefined;
	}
	try {
		const parsed = new URL(url);
		const { hostname } = parsed;
		if (hostname === 'loom.com' || hostname.endsWith('.loom.com')) {
			return 'loom';
		}
		if (parsed.pathname.startsWith('/wiki')) {
			return 'confluence';
		}
		return 'other';
	} catch {
		return undefined;
	}
};
